import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ExtraTable from '../layouts/components/extra/ExtraTable';
import Toolbar from '../layouts/components/extra/Toolbar';
import ExtraItem from '../layouts/components/extra/ExtraItem';
import {AlertExtraObject, BookmakerData, EventsStoredObjects, ExtraSettingsObject, User,} from '../@types/response';
import {getBookmakers} from '../store/selectors/getBookmakers';
import {getExtras} from '../store/selectors/extra/getExtras';
import {GetInitAction} from '../store/actions/extra/GetInitAction';
import {GetActiveExtraAction} from '../store/actions/extra/GetActiveExtraAction';
import BookExtraModal from '../layouts/components/extra/modals/BookExtraModal';
import getClient from '../store/selectors/getClient';
import SignChartModal from '../layouts/components/modals/SignChartModal';
import ExtraDetailsModal from '../layouts/components/extra/modals/ExtraDetailsModal';
import HideExtraModal from "../layouts/components/extra/modals/HideExtraModal";
import {AppDispatch} from "recharts/types/state/store";
import {getExtraBooks} from "../store/selectors/extra/getBooks";
import {getFixtures} from "../store/selectors/getFixtures";
import {getSettings} from "../store/selectors/extra/getSettings";
import {sortEvent} from "../store/utils/extraUtils";
import {ActiveEventIds} from "../store/utils/searchFixtures";

const Extra: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const fixtures: EventsStoredObjects = useSelector(getFixtures);
    const extras: AlertExtraObject[] = useSelector(getExtras);
    const bookmakers: BookmakerData = useSelector(getBookmakers);
    const client: undefined | User = useSelector(getClient);
    const books: number[] = useSelector(getExtraBooks)
    const settings: ExtraSettingsObject = useSelector(getSettings)

    const sortedExtras = useMemo(() =>
                    [...extras].sort((a, b) => sortEvent(a, b, fixtures, settings)),
            [extras, fixtures, settings]
    );

    const enabledBookmakers: ActiveEventIds = useMemo(() => {
        return new Set(Object.keys(bookmakers)
                .filter((id) => books.includes(parseInt(id)))
                .map((b) => parseInt(b)))
    }, [bookmakers, books])

    useEffect(() => {
        dispatch(GetInitAction(client?.id || ''));
        dispatch(GetActiveExtraAction());
        document.title = 'EXTRA - OddMonitor';
    }, []);

    if (!Object.keys(bookmakers).length) {
        return (
                <div>
                    <div
                            id='toolbar-extra'
                            className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
                    >
                        <Toolbar/>
                    </div>
                    <div className='mt-16'>
                        <ExtraTable/>
                    </div>
                    <div>Loading</div>
                </div>
        );
    }

    return <React.Fragment>
        <div
                id='toolbar-extra'
                className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
        >
            <Toolbar/>
        </div>
        <div className='mt-16 mx-4'>
            <ExtraTable>
                {sortedExtras
                        //TODO: move this check in utils?
                        .filter(alert => enabledBookmakers.has(alert.bookmakerId) && (client?.client == null || client.client === alert.bookmakerId))
                        .map((alert: AlertExtraObject, idx: number) => <ExtraItem alert={alert}
                                                                                  key={`${alert.id}x${idx}`}
                                                                                  event={fixtures[alert.id]}/>)}
            </ExtraTable>
        </div>

        <ExtraDetailsModal/>
        <BookExtraModal/>
        <SignChartModal/>
        <HideExtraModal/>
    </React.Fragment>;
};

export default Extra;
